import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PriceInput } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { getBudgetValue } from '@spotahome/marketplace-common/src/utils/filters';

import { isValidPriceRange } from '../../utils/priceFilter';

import './PriceRangeHelper.scss';

const PriceRangeHelper = ({
  budget,
  currencyIsoCode,
  updateFiltersWith,
  maxPriceInCity
}) => {
  const [hasError, setHasError] = useState(false);

  const splitBudget = budget?.split('-');
  const budgetMin = parseInt(splitBudget[0], 10) || 0;
  const budgetMax = parseInt(splitBudget[1], 10) || '';

  const validatePriceRange = () => {
    if (isValidPriceRange({ minPrice: budgetMin, maxPrice: budgetMax })) {
      setHasError(false);
    } else {
      setHasError(true);
    }
  };

  useEffect(() => {
    validatePriceRange();
  }, [budgetMin, budgetMax]);

  const updateBudget = ({ minPrice, maxPrice }) => {
    const budgetValue = getBudgetValue({
      minBudget: minPrice || budgetMin,
      maxBudget: maxPrice || budgetMax
    });
    updateFiltersWith({ budget: budgetValue });
  };

  const handleMinPriceChange = ({ value }) => {
    updateBudget({ minPrice: value });
  };

  const handleMaxPriceChange = ({ value }) => {
    updateBudget({ maxPrice: value });
  };

  return (
    <>
      <div className="price-range-helper__inputs">
        <div className="price-range-helper__input">
          <PriceInput
            title={trans('filters.price.from')}
            name="minPrice"
            id="minPrice"
            handleOnChange={handleMinPriceChange}
            currencyIsoCode={currencyIsoCode}
            value={budgetMin}
            max={budgetMax}
            placeholder="0"
            hasError={hasError}
          />
        </div>
        <span className="price-range-helper__separator">-</span>
        <div className="price-range-helper__input">
          <PriceInput
            title={trans('filters.price.to')}
            name="maxPrice"
            id="maxPrice"
            handleOnChange={handleMaxPriceChange}
            currencyIsoCode={currencyIsoCode}
            value={budgetMax}
            min={budgetMin}
            placeholder={`${maxPriceInCity}+`}
            hasError={hasError}
          />
        </div>
      </div>

      {hasError && (
        <p className="price-range-helper__error">
          {trans('search.filters.price-range-helper.error')}
        </p>
      )}
    </>
  );
};

PriceRangeHelper.propTypes = {
  budget: PropTypes.string,
  currencyIsoCode: PropTypes.string.isRequired,
  updateFiltersWith: PropTypes.func.isRequired,
  maxPriceInCity: PropTypes.number.isRequired
};

PriceRangeHelper.defaultProps = {
  budget: ''
};

export default PriceRangeHelper;
